import { render, staticRenderFns } from "./clinicFeeManagement.vue?vue&type=template&id=7c3d5b23&scoped=true"
import script from "./clinicFeeManagement.vue?vue&type=script&lang=js"
export * from "./clinicFeeManagement.vue?vue&type=script&lang=js"
import style0 from "./clinicFeeManagement.vue?vue&type=style&index=0&id=7c3d5b23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3d5b23",
  null
  
)

export default component.exports